import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { postnumer } from 'postnumer';
import kennitala from './kennitala';

const UserForm = () => {
  const { register, watch, setValue, formState: { errors } } = useFormContext();
  const postalCode = watch("zip_code");

  const emailPatternObj = {
    value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
    message: 'Netfang er ekki gilt',
  }

  const validateKennitala = (value) => {

    return kennitala.isPerson(value) || 'Kennitala er ekki rétt';
  }

  useEffect(() => {
    if (postalCode && postalCode.length >= 3) {
      const place = postnumer[postalCode];
      if (place) {
        setValue("city", place.name);
        setValue("country", "Ísland");
        setValue("country_code", "IS");
      } else {
        setValue("city", "");
        setValue("country", "");
      }
    }
  }, [postalCode]);

  // Helper function for form
  const getInputField = (name, required, pattern = {}, validate = undefined) => {

    let options = { pattern: pattern }
    if (required) {
      options.required = required;
    }
    if (validate) {
      delete options.pattern;
      options.validate = validate;
    }
    return <>
      <input className="form-control" id={name} type="text" {...register(name, options)} />
      {errors[name] ? <small className="error-msg text-start">{errors[name].message}</small> : null}
    </>
  }

  return (
    <>
    
      <div className="col-12 mb-4">
        <div className="row mb-3">
          <div className="col-md-6 col-12">
            <label className="form-label" htmlFor="name">Nafn forráðamanns: </label>
            {getInputField("name", "Vinsamlegast fyllið út nafn forráðamanns")}
          </div>
          <div className="col-md-6 col-12">
            <label className="form-label" htmlFor="ssn">Kennitala forráðamanns: </label>
            {getInputField("ssn", "Vinsamlegast fyllið út kennitölu forráðamanns", {}, validateKennitala)}
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-md-6 col-12">
            <label className="form-label" htmlFor="description">Nafn leynifélagsmeðlims (má sleppa): </label>
            {getInputField("description")}
          </div>
          <div className="col-md-6 col-12">
            <label className="form-label" htmlFor="email">Netfang: </label>
            {getInputField("email", "Vinsamlegast fyllið út netfang", emailPatternObj)}
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-md-4 col-12">
            <label className="form-label" htmlFor="address">Heimilisfang (hvert á bókin að berast?): </label>
            {getInputField("address", "Vinsamlegast fyllið út heimilisfang")}
          </div>
          <div className="col-md-2 col-12">
            <label className="form-label" htmlFor="zip_code">Póstnúmer: </label>
            {getInputField("zip_code", "Vinsamlegast fyllið út póstnúmer")}
          </div>
          <div className="col-md-3 col-12">
            <label className="form-label" htmlFor="city">Borg: </label>
            {getInputField("city", "Vinsamlegast fyllið út borg")}
          </div>
          <div className="col-md-3 col-12">
            <label className="form-label" htmlFor="country">Land: </label>
            {getInputField("country", "Vinsamlegast fyllið út land")}
          </div>
        </div>
      </div>
    </>
  );
};

export default UserForm;